import { DatePicker, Form } from 'antd';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { range } from 'lodash';
import { useEffect, useState } from 'react';

dayjs.extend(isSameOrAfter);

const AntdDateRangeLimitDate = ({
  name,
  width,
  height = 36,
  dateFormat,
  listDisable,
  status,
  isShowTime,
  form,
  onChangeDate,
  value,
  allowClear = false,
  setDateRange
}) => {
  const [dateFirstSelect, setDateFirstSelect] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  useEffect(() => {
    if (!isCalendarOpen) {
      setDateFirstSelect(null);
    }
  }, [isCalendarOpen]);

  const onOkSelectedDate = (dates) => {
    if (dates) {
      let dateFrom;
      let dateTo;
      if (status === 'SCHEDULED') {
        if (dates[0]) {
          dateFrom = dayjs(dates[0]).isBefore(dayjs()) ? null : dayjs(dates[0]);
          form.setFields([
            {
              name: 'publishedFromToDate',
              errors: [],
            },
          ]);
        }
      } else {
        dateFrom = null;
      }
      if (dates[1]) {
        dateTo = dayjs(dates[1]).isBefore(dayjs()) ? null : dayjs(dates[1]);
      }
      form.setFieldValue('publishedFromToDate', [dateFrom, dateTo]);
    }
  };

  const disableRangeTime = (date, _type) => {
    if (!date) {
      return {
        disabledHours: () => range(0, 24),
        disabledMinutes: () => range(0, 60),
      };
    }
    if (dayjs().isSameOrAfter(date, 'hours')) {
      return {
        disabledHours: () => range(0, dayjs().hour()),
        disabledMinutes: () => range(0, dayjs().minute() + 1),
      };
    }
    if (dayjs().isSameOrAfter(date, 'days')) {
      return {
        disabledHours: () => range(0, dayjs().hour()),
      };
    }
  };

  const disabledDate = (current) => {
    const dateFrom = value?.[0];
    if (dateFirstSelect) {
      return (
        current.isBefore(dayjs(dateFirstSelect).subtract(180, 'day'), 'day') ||
        current.isAfter(dayjs(dateFirstSelect).add(180, 'day'), 'day')
      );
    }
    if (dateFrom) {
      return (
        current.isBefore(dayjs(dateFrom).subtract(180, 'day'), 'day') ||
        current.isAfter(dayjs(dateFrom).add(180, 'day'), 'day')
      );
    }
    return false;
  };

  const handleCalendarChange = (dates, _, info) => {
    if (isCalendarOpen) {
      const diff = Math.abs(dayjs(dates[0]).diff(dayjs(dates[1]), 'day'));
      if (diff > 180) {
        const newDate2 = dayjs(dates[0]).isBefore(dayjs(dates[1]))
          ? dayjs(dates[0]).add(180, 'day')
          : dayjs(dates[0]).subtract(180, 'day');
        const sortedDates = dayjs(dates[0]).isAfter(newDate2)
          ? { dateFrom: newDate2, dateTo: dates[0] }
          : { dateFrom: dates[0], dateTo: newDate2 };

          setDateRange(sortedDates);
      }
      if (info.range === 'start' && dates[0]) {
        setDateFirstSelect(dates[0]);
      } else if (info.range === 'end' && dates[1]) {
        setDateFirstSelect(dates[1]);
      }
    }
  };

  return (
    <Form.Item name={name} style={{ marginBottom: 0 }}>
      <DatePicker.RangePicker
        showTime={
          isShowTime && {
            format: 'HH:mm',
          }
        }
        format={dateFormat}
        style={{ width: width ?? '250px', height: height }}
        placeholder={['日付From', '日付To']}
        disabled={listDisable}
        allowEmpty={true}
        inputReadOnly={true}
        disabledDate={disabledDate}
        disabledTime={disableRangeTime}
        onChange={onChangeDate}
        defaultValue={value}
        value={value}
        onOk={onOkSelectedDate}
        allowClear={allowClear}
        onCalendarChange={handleCalendarChange}
        dateRender={(current) => {
          const isSelected =
            (value?.[0] && current.isSame(value?.[0], 'day')) ||
            (value?.[1] && current.isSame(value?.[1], 'day'));

          return (
            <div
              className="ant-picker-cell-inner"
              onClick={() => {
                if (isSelected) {
                  setDateFirstSelect(current);
                }
              }}
            >
              {current.date()}
            </div>
          );
        }}
        onOpenChange={(open) => {
          setIsCalendarOpen(open);
        }}
      />
    </Form.Item>
  );
};
export default AntdDateRangeLimitDate;
